// DashboardUser.jsx - Updated dengan navigasi ke detail buku
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LayoutUser from '../components/layoutUser';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaBook, FaStar, FaClock, FaTrophy, FaFilter, FaTimes } from 'react-icons/fa';

const DashboardUser = () => {
    const [allBooks, setAllBooks] = useState([]);
    const [categories, setCategories] = useState([]);
    const [topBorrowers, setTopBorrowers] = useState([]);
    const [newBooks, setNewBooks] = useState([]);
    const [filteredBooks, setFilteredBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showMobileFilter, setShowMobileFilter] = useState(false);
    const [animateCards, setAnimateCards] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');

        if (!token || role !== 'anggota') {
            navigate('/login');
            return;
        }

        fetchData();
    }, [navigate]);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const headers = { 'x-auth-token': token };

            const [bukuResponse, kategoriResponse, topBorrowResponse] = await Promise.all([
                axios.get(`${process.env.REACT_APP_API_URL}/buku`, { headers }),
                axios.get(`${process.env.REACT_APP_API_URL}/kategori`, { headers }),
                axios.get(`${process.env.REACT_APP_API_URL}/peminjaman/top-borrow?limit=6`, { headers }).catch(() => null)
            ]);

            const books = bukuResponse.data;
            const categoriesData = kategoriResponse.data;

            setAllBooks(books);
            setFilteredBooks(books);
            setCategories(categoriesData);

            if (topBorrowResponse?.data) {
                setTopBorrowers(topBorrowResponse.data);
            } else {
                setTopBorrowers([]);
            }

            try {
                const newBooksResponse = await axios.get(`${process.env.REACT_APP_API_URL}/buku/new-books?limit=6`, { headers });
                setNewBooks(newBooksResponse.data);
            } catch (error) {
                const sortedNewBooks = books
                    .sort((a, b) => new Date(b.tanggal_pendaftaran) - new Date(a.tanggal_pendaftaran))
                    .slice(0, 6);
                setNewBooks(sortedNewBooks);
            }

            setLoading(false);
            setTimeout(() => setAnimateCards(true), 100);

        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response?.status === 401) {
                navigate('/login');
            }
            setLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        filterBooks(query, selectedCategory);
    };

    const handleCategoryChange = (e) => {
        const category = e.target.value;
        setSelectedCategory(category);
        filterBooks(searchQuery, category);
    };

    const filterBooks = (query, category) => {
        let updatedBooks = allBooks;

        if (query) {
            const lowerCaseQuery = query.toLowerCase();
            updatedBooks = updatedBooks.filter(book =>
                (book.judul && book.judul.toLowerCase().includes(lowerCaseQuery)) ||
                (book.pengarang && book.pengarang.toLowerCase().includes(lowerCaseQuery)) ||
                (book.no_induk_buku && book.no_induk_buku.toLowerCase().includes(lowerCaseQuery))
            );
        }

        if (category) {
            updatedBooks = updatedBooks.filter(book => {
                if (book.kategori_list && Array.isArray(book.kategori_list)) {
                    return book.kategori_list.includes(parseInt(category));
                }
                else if (book.id_kategori) {
                    return book.id_kategori === parseInt(category);
                }
                else if (book.nama_kategori) {
                    const selectedCategoryName = categories.find(cat => cat.id === parseInt(category))?.nama_kategori;
                    if (selectedCategoryName) {
                        return book.nama_kategori.includes(selectedCategoryName);
                    }
                }
                return false;
            });
        }

        setFilteredBooks(updatedBooks);
    };

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour >= 5 && hour < 11) return 'Pagi';
        if (hour >= 11 && hour < 15) return 'Siang';
        if (hour >= 15 && hour < 18) return 'Sore';
        return 'Malam';
    };

    const getTrophyStyle = (index) => {
        if (index === 0) return { color: '#FFD700', size: isMobile ? 18 : 24 };
        if (index === 1) return { color: '#C0C0C0', size: isMobile ? 16 : 22 };
        if (index === 2) return { color: '#CD7F32', size: isMobile ? 14 : 20 };
        return null;
    };

    const getBorderColor = (index) => {
        if (index === 0) return '#FFD700';
        if (index === 1) return '#C0C0C0';
        if (index === 2) return '#CD7F32';
        return '#ddd';
    };

    const getBadgeStyle = (index) => {
        if (index === 0) return { background: 'linear-gradient(135deg, #FFD700, #FFA500)', color: '#fff' };
        if (index === 1) return { background: 'linear-gradient(135deg, #C0C0C0, #A8A8A8)', color: '#fff' };
        if (index === 2) return { background: 'linear-gradient(135deg, #CD7F32, #B8860B)', color: '#fff' };
        return { background: '#e3f2fd', color: '#1979d2' };
    };

    const MemberCard = ({ member, index }) => {
        const trophyStyle = getTrophyStyle(index);
        const borderColor = getBorderColor(index);
        const badgeStyle = getBadgeStyle(index);

        return (
            <div 
                className="member-card"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    padding: isMobile ? '8px' : '10px',
                    borderRadius: '8px',
                    position: 'relative',
                    opacity: isMobile ? 0 : (animateCards ? 1 : 0),
                    transform: !isMobile && (animateCards ? 'translateY(0)' : 'translateY(20px)'),
                    transition: !isMobile ? `all 0.5s ease ${index * 0.1}s` : 'none',
                    animation: isMobile && animateCards ? `slideInFromRight 0.5s ease-out forwards` : 'none',
                    animationDelay: isMobile ? `${index * 0.1}s` : '0s',
                }}
            >
                {trophyStyle && (
                    <div className="trophy-badge" style={{
                        position: 'absolute',
                        top: '-5px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: 'white',
                        borderRadius: '50%',
                        padding: isMobile ? '3px' : '6px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        animation: 'bounce 2s infinite'
                    }}>
                        <FaTrophy 
                            size={trophyStyle.size} 
                            style={{ color: trophyStyle.color }}
                        />
                    </div>
                )}
                
                <div className="profile-image" style={{ 
                    width: isMobile ? '65px' : '100px', 
                    height: isMobile ? '65px' : '100px', 
                    borderRadius: '50%', 
                    overflow: 'hidden', 
                    border: `3px solid ${borderColor}`, 
                    marginBottom: '8px',
                    marginTop: trophyStyle ? (isMobile ? '8px' : '15px') : '0',
                    boxShadow: index < 3 ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
                    transition: 'transform 0.3s ease'
                }}>
                    {member.foto_profile ? (
                        <img
                            src={`${process.env.REACT_APP_BASE_URL}${member.foto_profile}`}
                            alt={member.nama_lengkap}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.target.src = 'https://via.placeholder.com/100'; }}
                        />
                    ) : (
                        <div style={{
                            width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: '#e9ecef', color: '#6c757d', fontSize: isMobile ? '28px' : '40px'
                        }}>
                            {member.nama_lengkap ? member.nama_lengkap.charAt(0).toUpperCase() : '?'}
                        </div>
                    )}
                </div>
                <h4 style={{
                    margin: '0',
                    fontSize: isMobile ? '11px' : '14px',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: isMobile ? '70px' : '100px'
                }}>
                    {member.nama_lengkap}
                </h4>
                {!isMobile && (
                    <div style={{
                        ...badgeStyle,
                        padding: isMobile ? '3px 6px' : '4px 8px',
                        borderRadius: '12px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontSize: isMobile ? '10px' : '11px',
                        fontWeight: 'bold',
                        marginTop: '4px',
                        boxShadow: index < 3 ? '0 2px 6px rgba(0,0,0,0.2)' : 'none'
                    }}>
                        <FaStar size={8} />
                        {member.borrow_count} Peminjaman
                    </div>
                )}
            </div>
        );
    };

    const BookCard = ({ book, index }) => (
        <div 
            className="book-card"
            onClick={() => navigate(`/user/book/${book.id}`)}
            style={{
                background: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                cursor: 'pointer',
                height: isMobile ? '180px' : '220px',
                opacity: animateCards ? 1 : 0,
                transform: animateCards ? 'scale(1)' : 'scale(0.9)',
                transition: `all 0.4s ease ${index * 0.05}s`
            }}
        >
            <div style={{ 
                height: isMobile ? '100px' : '120px', 
                overflow: 'hidden', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                background: '#e9ecef' 
            }}>
                {book.foto_buku ? (
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/images/buku/${book.foto_buku}`}
                        alt={book.judul}
                        style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', transition: 'transform 0.3s' }}
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/100'; }}
                    />
                ) : (
                    <FaBook size={isMobile ? 36 : 48} style={{ color: '#adb5bd', opacity: 0.6 }} />
                )}
            </div>
            <div style={{ padding: isMobile ? '8px' : '12px' }}>
                <h4 style={{
                    margin: '0 0 4px 0',
                    fontSize: isMobile ? '12px' : '14px',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    {book.judul}
                </h4>
                <p style={{
                    margin: '0',
                    fontSize: isMobile ? '10px' : '12px',
                    color: '#6c757d',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    {book.pengarang || 'Penulis tidak diketahui'}
                </p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                color: '#6c757d'
            }}>
                <div className="spinner" style={{
                    width: isMobile ? '40px' : '50px',
                    height: isMobile ? '40px' : '50px',
                    border: '5px solid #f3f3f3',
                    borderTop: '5px solid #3498db',
                    borderRadius: '50%'
                }}></div>
                <p style={{ marginTop: '20px', fontSize: isMobile ? '14px' : '16px' }}>Loading...</p>
            </div>
        );
    }

    return (
        <LayoutUser>
            <div style={{ 
                maxWidth: '1200px', 
                margin: '-25px auto',
                padding: isMobile ? '10px' : '20px'
            }}>
                {/* Welcome Message */}
                <div className="welcome-banner" style={{
                    padding: isMobile ? '15px' : '20px',
                    marginBottom: isMobile ? '20px' : '30px',
                    background: 'linear-gradient(135deg, #758bebff 0%, #3498db 100%)',
                    borderRadius: '12px',
                    color: 'white',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    opacity: animateCards ? 1 : 0,
                    transform: animateCards ? 'translateY(0)' : 'translateY(-20px)',
                    transition: 'all 0.6s ease'
                }}>
                    <h2 style={{ 
                        margin: '0 0 8px 0', 
                        fontSize: isMobile ? '20px' : '24px',
                        fontWeight: 'bold'
                    }}>
                        Selamat {getGreeting()}! 👋
                    </h2>
                    <p style={{ margin: 0, fontSize: isMobile ? '13px' : '15px', opacity: 0.95 }}>
                        Temukan buku favoritmu di sini dan lihat koleksi terbaru kami.
                    </p>
                </div>

                {/* Mobile Filter Button */}
                {isMobile && (
                    <button
                        onClick={() => setShowMobileFilter(!showMobileFilter)}
                        style={{
                            width: '100%',
                            padding: '12px',
                            marginBottom: '15px',
                            background: showMobileFilter ? '#667eea' : 'white',
                            color: showMobileFilter ? 'white' : '#333',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        {showMobileFilter ? <FaTimes /> : <FaFilter />}
                        {showMobileFilter ? 'Tutup Filter' : 'Buka Filter'}
                    </button>
                )}

                {/* Search Bar and Filters */}
                <div style={{ 
                    marginBottom: isMobile ? '20px' : '30px',
                    display: isMobile && !showMobileFilter ? 'none' : 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: '10px',
                    opacity: animateCards ? 1 : 0,
                    transform: animateCards ? 'translateY(0)' : 'translateY(-10px)',
                    transition: 'all 0.5s ease 0.2s'
                }}>
                    <div style={{ 
                        flex: 1, 
                        position: 'relative',
                        animation: 'slideIn 0.5s ease'
                    }}>
                        <input
                            type="text"
                            placeholder="Cari buku..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{
                                width: '100%',
                                padding: isMobile ? '10px 10px 10px 35px' : '12px 12px 12px 40px',
                                borderRadius: '8px',
                                border: '2px solid #e0e0e0',
                                fontSize: isMobile ? '14px' : '16px',
                                boxSizing: 'border-box',
                                transition: 'border-color 0.3s ease',
                                outline: 'none'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#667eea'}
                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                        />
                        <FaSearch style={{
                            position: 'absolute',
                            left: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#999',
                            fontSize: isMobile ? '14px' : '16px'
                        }} />
                    </div>
                    <select
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        style={{
                            padding: isMobile ? '10px' : '12px',
                            borderRadius: '8px',
                            border: '2px solid #e0e0e0',
                            fontSize: isMobile ? '13px' : '14px',
                            minWidth: isMobile ? '100%' : '200px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            outline: 'none'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#667eea'}
                        onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                    >
                        <option value="">Semua Kategori</option>
                        {categories.map(category => (
                            <option key={category.id} value={category.id}>{category.nama_kategori}</option>
                        ))}
                    </select>
                </div>

                {/* Top Borrow Section */}
                {!searchQuery && !selectedCategory && (
                    <div style={{ marginBottom: isMobile ? '24px' : '32px' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '16px', 
                            gap: '8px'
                        }}>
                            <FaStar style={{ color: '#ffd700', fontSize: isMobile ? '18px' : '20px' }} />
                            <h3 style={{ 
                                margin: 0, 
                                fontSize: isMobile ? '18px' : '20px', 
                                fontWeight: 'bold' 
                            }}>
                                Top Borrow
                            </h3>
                        </div>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(auto-fill, minmax(100px, 1fr))',
                            gap: isMobile ? '12px' : '15px',
                            justifyContent: 'center',
                            alignItems: 'start'
                        }}>
                            {topBorrowers.length > 0 ? (
                                topBorrowers.map((member, index) => (
                                    <MemberCard key={`top-borrower-${member.id}`} member={member} index={index} />
                                ))
                            ) : (
                                <div style={{
                                    gridColumn: '1 / -1',
                                    textAlign: 'center',
                                    color: '#666',
                                    padding: isMobile ? '30px' : '40px'
                                }}>
                                    <FaStar size={isMobile ? 36 : 48} style={{ marginBottom: '12px', opacity: 0.3 }} />
                                    <p style={{ fontSize: isMobile ? '13px' : '15px' }}>Belum ada data peminjaman</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* New Books Section */}
                {!searchQuery && !selectedCategory && (
                    <div style={{ marginBottom: isMobile ? '24px' : '32px' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '16px', 
                            gap: '8px' 
                        }}>
                            <FaClock style={{ color: '#17a2b8', fontSize: isMobile ? '18px' : '20px' }} />
                            <h3 style={{ 
                                margin: 0, 
                                fontSize: isMobile ? '18px' : '20px', 
                                fontWeight: 'bold' 
                            }}>
                                Koleksi Terbaru
                            </h3>
                        </div>
                        <p style={{ 
                            margin: '0 0 20px 0', 
                            color: '#666',
                            fontSize: isMobile ? '12px' : '14px',
                            lineHeight: '1.5'
                        }}>
                            Merupakan daftar koleksi-koleksi terbaru kami. Tidak semuanya baru,
                            adapula koleksi yang data-datanya sudah diperbaiki. Selamat menikmati
                        </p>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(180px, 1fr))',
                            gap: isMobile ? '12px' : '16px',
                            marginBottom: '20px'
                        }}>
                            {newBooks.length > 0 ? (
                                newBooks.map((book, index) => (
                                    <BookCard key={`new-book-${book.id}`} book={book} index={index} />
                                ))
                            ) : (
                                <div style={{
                                    gridColumn: '1 / -1',
                                    textAlign: 'center',
                                    color: '#666',
                                    padding: isMobile ? '30px' : '40px'
                                }}>
                                    <FaBook size={isMobile ? 36 : 48} style={{ marginBottom: '12px', opacity: 0.3 }} />
                                    <p style={{ fontSize: isMobile ? '13px' : '15px' }}>Belum ada buku terbaru</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Search Results */}
                {(searchQuery || selectedCategory) && (
                    <div>
                        <h3 style={{ 
                            fontSize: isMobile ? '18px' : '20px', 
                            fontWeight: 'bold', 
                            marginBottom: '20px' 
                        }}>
                            Hasil Pencarian
                        </h3>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(180px, 1fr))',
                            gap: isMobile ? '12px' : '16px',
                            marginBottom: '20px'
                        }}>
                            {filteredBooks.length > 0 ? (
                                filteredBooks.map((book, index) => (
                                    <BookCard key={`search-${book.id}`} book={book} index={index} />
                                ))
                            ) : (
                                <div style={{
                                    gridColumn: '1 / -1',
                                    textAlign: 'center',
                                    color: '#666',
                                    padding: isMobile ? '30px' : '40px'
                                }}>
                                    <FaBook size={isMobile ? 36 : 48} style={{ marginBottom: '12px', opacity: 0.3 }} />
                                    <p style={{ fontSize: isMobile ? '13px' : '15px' }}>
                                        Tidak ada buku yang sesuai dengan pencarian Anda
                                    </p>
                                    <p style={{ fontSize: isMobile ? '11px' : '14px', marginTop: '8px' }}>
                                        Coba gunakan kata kunci yang berbeda atau hapus filter
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                
                @keyframes bounce {
                    0%, 100% { transform: translateX(-50%) translateY(0); }
                    50% { transform: translateX(-50%) translateY(-5px); }
                }

                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateX(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                
                @keyframes slideInFromRight {
                    from {
                        opacity: 0;
                        transform: translateX(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }

                .spinner {
                    animation: spin 1s linear infinite;
                }

                .member-card:hover .profile-image {
                    transform: scale(1.1);
                }

                .book-card:hover {
                    transform: translateY(-5px) scale(1.02);
                    box-shadow: 0 8px 16px rgba(0,0,0,0.15);
                }

                .book-card:hover img {
                    transform: scale(1.05);
                }

                .welcome-banner {
                    position: relative;
                    overflow: hidden;
                }

                .welcome-banner::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    right: -50%;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
                    animation: pulse 3s ease-in-out infinite;
                }

                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 0.5; }
                    50% { transform: scale(1.1); opacity: 0.8; }
                }
            `}</style>
        </LayoutUser>
    );
};

export default DashboardUser;